import { VacationsScheduleSubordinates } from 'features/vacationsScheduleSubordinates/VacationsScheduleSubordinates';
import { useTitle } from '../helpers';

/**
 * @page Vacations
 */
const VacationScheduleSubordinatesPage = () => {
  useTitle('Планирование отпусков сотрудников');

  return (
    <div>
      <VacationsScheduleSubordinates />
    </div>
  );
};

export default VacationScheduleSubordinatesPage;
